<template>
  <div
    class="grid lg:grid-cols-2 relative lg:h-screen pb-8 lg:pb-0 tracking-wider"
  >
    <div class="px-4 lg:h-full lg:overflow-auto">
      <div
        v-for="(item, index) in credits.text"
        :key="index"
        class="py-8 px-4 border-b border-black lg:last:border-0"
      >
        <h1 class="">
          {{ item.title }}
        </h1>
        <div v-html="item.text"></div>
      </div>
    </div>
    <div class="hidden lg:block py-4 absolute top-0 left-1/2 w-px h-full">
      <div class="w-full h-full bg-black"></div>
    </div>
    <partners />
  </div>
</template>

<script>
const Partners = () =>
  import(/* webpackChunkName: "Partners" */ "@/components/Partners.vue");
export default {
  components: {
    Partners,
  },
  created() {
    if (!this.$store.state.credits.title) {
      this.$store.dispatch("loadCredits");
    }
  },
  computed: {
    credits() {
      return this.$store.state.credits;
    },
  },
};
</script>
